import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  SET_STATUS,
  RESET_STATUS,
  SET_ERROR,
  FETCH_ORGANIZATIONS_SUCCESS,
  FETCH_SETTINGS_SUCCESS,
  EDIT_ORGANIZATION_SUCCESS,
  TOGGLE_2FA_SUCCESS,
  DELETE_ORGANIZATION_SUCCESS
} from "./organizationsSagas";
import sortBy from "lodash/sortBy";

export const initialState = {
  isLoading: true,
  status: "idle",
  errors: null,
  organizations: [],
  commonSettings: {}
};

export default handleActions(
  {
    [SET_ERROR]: (state, action) => ({
      ...state,
      status: "failed",
      errors: action.payload
    }),
    [SET_STATUS]: (state, action) => ({
      ...state,
      status: action.payload
    }),
    [RESET_STATUS]: (state) => ({
      ...state,
      status: "idle",
      errors: null
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [FETCH_ORGANIZATIONS_SUCCESS]: (state, action) => ({
      ...state,
      organizations: action.payload
    }),
    [FETCH_SETTINGS_SUCCESS]: (state, action) => ({
      ...state,
      commonSettings: action.payload
    }),
    [TOGGLE_2FA_SUCCESS]: (state, action) => ({
      ...state,
      commonSettings: { ...state.commonSettings, global2fa: action.payload }
    }),
    [EDIT_ORGANIZATION_SUCCESS]: (state, { payload: { id, data, haveNamesChanged } }) => {
      const orgs = state.organizations.map((org) => (org.id == id ? data : org));
      return {
        ...state,
        status: "success",
        organizations: haveNamesChanged ? sortByName(orgs) : orgs
      };
    },
    [DELETE_ORGANIZATION_SUCCESS]: (state, { payload: { id } }) => ({
      ...state,
      organizations: state.organizations.filter((org) => org.id !== id)
    })
  },

  initialState
);

const sortByName = (arr) => {
  return sortBy(arr, [(org) => org.businessName.toLowerCase()]);
};
